import React from 'react';
import { TextField, InputAdornment, IconButton } from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

import {
  ADMIN_PASSWORD_REQUIREMENTS,
  adminPasswordProblems,
} from 'utils/adminPassword';

const helperFor = (value, problems) => {
  if (!value) return ADMIN_PASSWORD_REQUIREMENTS;
  if (problems.length === 0) return 'Strong password';
  return problems.map((problem) => (
    <span key={problem}>
      {problem}
      <br />
    </span>
  ));
};

const AdminPasswordField = ({
  value,
  showPassword,
  onChange,
  onToggleShow,
}) => {
  const problems = value ? adminPasswordProblems(value) : [];

  return (
    <TextField
      id="password"
      label="Admin password"
      required
      type={showPassword ? 'text' : 'password'}
      error={problems.length > 0}
      helperText={helperFor(value, problems)}
      onChange={(event) => onChange(event.target.value)}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="toggle password visibility"
              onClick={onToggleShow}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default AdminPasswordField;
